import { render } from "./Tolerations.vue?vue&type=template&id=3ed579d2&scoped=true"
import script from "./Tolerations.vue?vue&type=script&lang=js"
export * from "./Tolerations.vue?vue&type=script&lang=js"

import "./Tolerations.vue?vue&type=style&index=0&id=3ed579d2&lang=scss&scoped=true"

import exportComponent from "../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed579d2"]])

export default __exports__